export enum MessageType {
  Congratulations = 'congratulations',
  Advertising = 'advertising',
  Welcome = 'welcome',
  Promotion = 'promotion',
  Script = 'script',
  Tips = 'tips',
}
